module.exports = __webpack_public_path__ + "static/media/rabbitAlchemist.ed5d4114.png";